<template>
    
    <!-- Encabezado de la aplicación -->
    <div class="appHeader">
        <div class="left">
            <a href="#" class="headerButton goBack">
                <ion-icon name="chevron-back-outline"></ion-icon>
            </a>
        </div>
        <div class="pageTitle">
            Intercambio
        </div>
        <div class="right">
            <a href="#" class="headerButton" onclick="toastbox('toast-1', 2000)">
                <ion-icon name="refresh"></ion-icon>
            </a>
        </div>
    </div>
    <!-- * Encabezado de la aplicación -->

    <!-- toast superior -->
    <div id="toast-1" class="toast-box toast-top tap-to-close bg-primary">
        <div class="in">
            <div class="text">
                ¡Los tipos de cambio se han actualizado!
            </div>
        </div>
    </div>
    <!-- * toast superior -->


    <!-- Cápsula de la aplicación -->
    <div id="appCapsule">


        <form action="app-pages.php">

            <div class="section mt-4">
                <div class="card">
                    <div class="card-body">
                        <div class="form-group basic p-0">
                            <div class="exchange-heading">
                                <label class="group-label" for="fromAmount">De</label>
                                <div class="exchange-wallet-info">
                                    Balance : <strong> 5.506,12 USD</strong>
                                </div>
                            </div>
                            <div class="exchange-group">
                                <div class="input-col">
                                    <input type="text" class="form-control form-control-lg pe-0 border-0"
                                        id="fromAmount" placeholder="0" value="380" maxlength="10">
                                </div>
                                <div class="select-col">
                                    <select class="form-select form-select-lg currency">
                                        <option value="USD" selected>USD</option>
                                        <option value="BTC">BTC</option>
                                        <option value="ETH">ETH</option>
                                        <option value="ADA">ADA</option>
                                    </select>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <div class="section">
                <div class="exchange-line">
                    <div class="exchange-icon">
                        <ion-icon name="swap-vertical-outline"></ion-icon>
                    </div>
                </div>
            </div>

            <div class="section">
                <div class="card">
                    <div class="card-body">
                        <div class="form-group basic p-0">
                            <div class="exchange-heading">
                                <label class="group-label" for="toAmount">A</label>
                                <div class="exchange-wallet-info">
                                    Balance : <strong> 0,504 BTC</strong>
                                </div>
                            </div>
                            <div class="exchange-group">
                                <div class="input-col">
                                    <input type="text" class="form-control form-control-lg pe-0 border-0" id="toAmount"
                                        placeholder="0" value="0,014" maxlength="10">
                                </div>
                                <div class="select-col">
                                    <select class="form-select form-select-lg currency">
                                        <option value="USD">USD</option>
                                        <option value="BTC" selected>BTC</option>
                                        <option value="ETH">ETH</option>
                                        <option value="ADA">ADA</option>
                                    </select>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>


            <div class="section mt-2">
                <div class="row fontsize-caption">
                    <div class="col">
                        <b>1 BTC</b> = 39.019,09 USD
                    </div>
                    <div class="col text-end">
                        Tasa de comisión : <b>2%</b>
                    </div>
                </div>
            </div>

            <div class="form-button-group transparent">
                <button type="submit" class="btn btn-primary btn-block btn-lg">
                    Continuar
                </button>
            </div>
        </form>


    </div>
    <!-- * Cápsula de la aplicación -->

</template>

<script>
export default {
    data() {
        return {
        };
    },
    mounted() {
        this.$root.loadBackButtom();
    },
    methods: {
    }
}
</script>